// Small confirmation receipts survive reloads independently of the audio Blob.
// Failure to persist stops before confirmation, so retry cannot create paid
// work without remembering which generation the server accepted.
const keyFor = (id) => `hans_recording_session:${id}`;

export const recordingUploadSession = {
  read(id) {
    if (!id) return null;
    const raw = localStorage.getItem(keyFor(id));
    return raw ? JSON.parse(raw) : null;
  },
  save(id, session) {
    if (!id) throw new Error("Save this recording before uploading it.");
    localStorage.setItem(keyFor(id), JSON.stringify(session));
  },
};
